import axios from '@/libs/api.request'

export const login = ({ code, password }) => {
  const data = {
    code,
    password
  }
  return axios.request({
    url: 'print/agent/login',
    data,
    method: 'put'
  })
}

export const getUserInfo = (token) => {
  return axios.request({
    url: '/print/agent/operator',
    method: 'get'
  })
}

export const getUserList = data => {
  return axios.request({
    url: '/print/user/list',
    params: data,
    method: 'get'
  })
}

export const saveUser = data => {
  return axios.request({
    url: '/print/user',
    data,
    method: 'put'
  })
}

export const putRecharge = data => {
  return axios.request({
    url: '/print/user/recharge',
    data,
    method: 'put'
  })
}

export const getRecharge = data => {
  return axios.request({
    url: '/print/user/recharge',
    params: data,
    method: 'get'
  })
}

export const rechargePage = data => {
  return axios.request({
    url: '/print/user/recharge-list',
    params: data,
    method: 'get'
  })
}

export const ConsumptionRecord = data => {
  return axios.request({
    url: '/print/user/consumption',
    params: data,
    method: 'get'
  })
}

export const GetDispenseAccount = data => {
  return axios.request({
    url: '/print/user/dispenseaccount',
    params: data,
    method: 'get'
  })
}
export const SaveDispenseAccount = data => {
  return axios.request({
    url: '/print/user/dispenseaccount',
    data,
    method: 'put'
  })
}
export const InitPWD = data => {
  return axios.request({
    url: '/print/user/pwd/init',
    data,
    method: 'put'
  })
}
export const UserConsumptionRecord = data => {
  return axios.request({
    url: '/print/user/consumption/single',
    params: data,
    method: 'get'
  })
}

export const userCompany = (data) => {
  return axios.request({
    url: '/app/user_company',
    data,
    method: 'post'
  })
}
export const ClearUserMoney = (data) => {
  return axios.request({
    url: '/print/user/ClearUserMoney',
    data,
    method: 'post'
  })
}
export const SendUserCoupon = (data) => {
  return axios.request({
    url: '/print/user/sendCoupon',
    data,
    method: 'post'
  })
}
export const RechargeRfund = (data) => {
  return axios.request({
    url: '/print/user/recharge-refund',
    data,
    method: 'post'
  })
}
export const GetUserInfo = (params) => {
  return axios.request({
    url: '/print/user/GetUserInfo',
    params,
    method: 'get'
  })
}

export const GetGiftCouponRecords = (params) => {
  return axios.request({
    url: '/print/user/GetGiftCouponRecords',
    params,
    method: 'get'
  })
}
